<template>
  <AtroContent class="w-full pt-6 pb-6 first:pt-0 last:pb-0">
    <slot />
  </AtroContent>
</template>
